import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UpgraderBetSectionComponent } from '../upgrader-bet-section/upgrader-bet-section.component';
import { UpgraderMainComponent } from '../upgrader-main/upgrader-main.component';
import { UpgraderSelectedSkinsComponent } from '../upgrader-selected-skins/upgrader-selected-skins.component';
import { UpgraderSkinsSelectionComponent } from '../upgrader-skins-selection/upgrader-skins-selection.component';

@Component({
  selector: 'app-upgrader',
  templateUrl: './upgrader.component.html',
  styleUrls: ['./upgrader.component.scss'],
  standalone: true,
  imports: [
    UpgraderBetSectionComponent,
    UpgraderMainComponent,
    UpgraderSelectedSkinsComponent,
    UpgraderSkinsSelectionComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgraderComponent {}
